import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "./i18n";
import { initSentry } from "./observability";
import App from "@/App";

initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: register the app-shell Service Worker so the app opens instantly and keeps
// working when the connection drops. Registered after load so it never delays first
// paint; failures are non-fatal (the app works exactly as before without it).
if ("serviceWorker" in navigator) {
  // Auto-mise-à-jour : quand un NOUVEAU déploiement prend le contrôle (nouveau SW qui
  // s'active via skipWaiting+clients.claim), on recharge l'app UNE fois → tout le monde
  // (owner + chatteuses) tourne toujours sur la dernière version, sans Ctrl+Shift+R.
  // Garde-fou : on n'attache l'écouteur QUE si la page était déjà contrôlée au chargement
  // (= vraie mise à jour), sinon on éviterait un reload en boucle au tout premier visite.
  let _swRefreshing = false;
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (_swRefreshing) return;
      _swRefreshing = true;
      window.location.reload();
    });
  }
  // FILET ANTI-VERSION-PÉRIMÉE (04/09) : même en réseau-first, un client peut rester
  // sur l'ancien build (cache HTTP, ou repli hors-ligne du SW). Symptôme vécu : un
  // correctif déployé « ne passait pas » alors qu'il était bien en ligne. On compare
  // le bundle RÉELLEMENT chargé avec celui que le serveur annonce ; s'ils diffèrent,
  // on purge et on recharge UNE fois (garde en sessionStorage = jamais de boucle).
  window.addEventListener("load", () => {
    setTimeout(async () => {
      try {
        const html = await fetch("/index.html", { cache: "no-store" }).then((r) => r.text());
        const attendu = (html.match(/main\.[a-z0-9]+\.js/) || [])[0];
        const charge = performance.getEntriesByType("resource")
          .map((e) => (e.name.match(/main\.[a-z0-9]+\.js/) || [])[0]).find(Boolean);
        if (!attendu || !charge || attendu === charge) return;
        if (sessionStorage.getItem("chathub_maj") === attendu) return;  // déjà tenté
        sessionStorage.setItem("chathub_maj", attendu);
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
        window.location.reload();
      } catch (e) { /* hors ligne : on garde la version en cours */ }
    }, 2500);
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // Une app/PWA laissée ouverte longtemps ne vérifie les MAJ du SW que rarement →
      // on force un check toutes les heures pour que les déploiements arrivent vite.
      setInterval(() => { reg.update().catch(() => {}); }, 60 * 60 * 1000);
    }).catch(() => {});
  });
}
